export const SET_CMS_DATA = 'SET_CMS_DATA';

export const SET_CMS_DATA_REQUEST ="SET_CMS_DATA_REQUEST";
export const SET_CMS_DATA_SUCCESS ="SET_CMS_DATA_SUCCESS";
export const SET_CMS_DATA_FAILURE ="SET_CMS_DATA_FAILURE";